export const webApiUrl = "https://lu-api.everlogic.com/api";
//export const webApiUrl = "https://localhost:44375/api";